import React from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import { emptyValue } from "utils/emptyValue";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import Section from "views/common/section";
import type PaymentCardGatewayDetailViewModel from "viewModels/finance/payments/cardGateWay/paymentCardGatewayDetailViewModel";

export interface CounterpartiesInfoProps {
  vm: PaymentCardGatewayDetailViewModel;
}

const CounterpartiesInfo = observer((props: CounterpartiesInfoProps) => {
  const { vm } = props;

  return (
    <Section title={vm.translate("counterpartiesInfoTitle")} context>
      <Form.Row>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("cardNumber")}</Form.Label>
          <FakeInput target={vm.item} property="cardNumber" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("cardAssociation")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="cardAssociation"
            valueFormatter={value => (value ? vm.translateCardAssociation(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("bankAccount")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="bankAccount"
            valueFormatter={value => (value ? formatBankAccount(value) : emptyValue)}
          />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default CounterpartiesInfo;
